<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs :active-tab.sync="active_tab">

              <BTab :title="$t('FinanceReport')" v-if="get_access('finance_report')">
                <FinanceReport/>
              </BTab>
              <BTab :title="$t('AccountCirculation')" v-if="get_access('account_circulation')">
                <AccountCirculationReport/>
              </BTab>
              <BTab :title="$t('ItemsReport')">
                <ReportAllProduct/>
              </BTab>
              <BTab :title="$t('sidebars.productCardex')">
                <ReportProductCardexAmount/>
              </BTab>
              <BTab :title="$t('ReceiptsAndPayments')" v-if="get_access('pay_receive_report')">
                <ReportPayReceiveDocs/>
              </BTab>

              <BTab :title="$t('PeriodReportAmountCirc')" v-if="get_access('period_report')">
                <PeriodReportAmountCirculation/>
              </BTab>

              <BTab :title="$t('BankDifference')" v-if="get_access('bank_diffrence')">
                <AccountingReports/>
              </BTab>
              <BTab title="گزارش تجمیعی اشخاص" v-if="get_access('tajmi_persons_turnover')">
                <PersonsTurnoversReportComponent/>
              </BTab>
              <BTab :title="$t('VATReport')">
                <VATReport/>
              </BTab>

              <BTab :title="$t('payingList')">
                <PayingOrders/>
              </BTab>
<!--              <BTab v-if="has_permission('Backups')" :title="$t('GeneralBackup')">-->
<!--                <General/>-->
<!--              </BTab>-->
<!--              <BTab v-if="has_permission('Backups')" :title="$t('DataConvert')">-->
<!--                <DataConvert/>-->
<!--              </BTab>-->




            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];
import BTabs from "../../tabs/BTabs";

import ReportPayReceiveDocs from "./ReportPayReceiveDocs";
import ReportProductCardexAmount from "./ReportProductCardexAmount";
import AccountingReports from "./AccountingReports";
import AccountCirculationReport from "./Reports/AccountCirculationReport";
import PeriodReportAmountCirculation from "./Reports/PeriodReportAmountCirculation";
import FinanceReport from "./Reports/FinanceReport";
import ReportAllProduct from "./Reports/ReportAllProduct";
import PersonsTurnoversReportComponent from "./Reports/PersonsTurnoversReportComponent";
import General from "../settings/General";
import BTab from "../../tabs/BTab";
import DataConvert from "../settings/DataConvert";
import VATReport from "./VATReport.vue";
import PayingOrders from "../payOperation/PayingOrders.vue";
export default {
  name: 'Login',
  components: {
    PayingOrders,
    VATReport,
    BTab,
    BTabs,
    AccountingReports,
    ReportPayReceiveDocs,
    ReportProductCardexAmount,
    AccountCirculationReport,
    PeriodReportAmountCirculation,
    FinanceReport,
    ReportAllProduct,
    PersonsTurnoversReportComponent,
    General,
    DataConvert

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      active_tab:0,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    bus.$on("finance_report_selected", (data) => {
      // alert(data);
      this.active_tab = 1;
     // console.log("clicked"+data)
    });
  }, watch: {

  },
  methods: {

  }
}

</script>
